import { render, staticRenderFns } from "./render-direction-size.vue?vue&type=template&id=778b9d18&"
import script from "./render-direction-size.vue?vue&type=script&lang=js&"
export * from "./render-direction-size.vue?vue&type=script&lang=js&"
import style0 from "./render-direction-size.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports